import { isArray } from 'util';

export interface FormError {
    key: string;
    message: string;
}

export interface AllFormErrors {
    general: Array<(string | null)>;
    field: FormError[];
}

export const EmptyFormErrors: AllFormErrors = {
    general: [],
    field: [],
};

// Recursively finds values for keys `keyToFind` in `obj`, returning an array with the found values for the keys
const searchKey = (obj: any, keyToFind: string): any[] => {
    if (typeof obj !== 'object') return [];
    let results = [];

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (key === keyToFind) {
                results.push(obj[key]);
            }
            results = [...results, ...searchKey(obj[key], keyToFind)];
        }
    }

    return results;
};

export const getFormErrors = (e: any): FormError[] => {
    const errors: FormError[] = [];
    if (e.graphQLErrors && e.graphQLErrors[0] && e.graphQLErrors[0].extensions && e.graphQLErrors[0].extensions.validation) {
        const inputErrors = e.graphQLErrors[0].extensions.validation.input ?
            e.graphQLErrors[0].extensions.validation.input :
            e.graphQLErrors[0].extensions.validation;
        for (const key in inputErrors) {
            if (inputErrors.hasOwnProperty(key)) {
                const error: FormError = {key, message: isArray(inputErrors[key]) ? inputErrors[key].join('<br />') : inputErrors[key]};
                errors.push(error);
            }
        }
    }
    return errors;
};

export const getError = (name: string | string[], allFormErrors: AllFormErrors): string => {
    let result = '';
    if (allFormErrors && allFormErrors.field) {
        const keys = isArray(name) ? name : [name];
        result = allFormErrors.field.filter((value) => keys.includes(value.key)).map((value) => value.message).join(', ');
    }
    return result;
};

const getFieldError = (key: string, message: string | string[]): FormError => {
    let newMessage: string | string[] = message;
    if (isArray(message)) {
        newMessage = message.join(', ');
    } else if (typeof message === 'object') {
        newMessage = Object.keys(message).map((messageKey: string) => message[messageKey]).join(', ');
    } else {
        newMessage = message;
    }

    return {key, message: newMessage};
};

export const getAllFormErrors = (e: any): AllFormErrors => {
    const general: string[] = [];
    const field: FormError[] = [];

    if (e.graphQLErrors && isArray(e.graphQLErrors)) {
        (e.graphQLErrors as any[]).forEach(error => {
            if (error.extensions && error.extensions.validation) {
                for (const errorKey in error.extensions.validation) {
                    if (error.extensions.validation.hasOwnProperty(errorKey)) {
                        if (errorKey === 'input') {
                            const inputErrors = error.extensions.validation.input;
                            for (const key in inputErrors) {
                                if (inputErrors.hasOwnProperty(key) && isNaN(parseInt(key, 10))) {
                                    field.push(getFieldError(key, inputErrors[key]));
                                }
                            }
                        } else {
                            if (isNaN(parseInt(errorKey, 10))) {
                                field.push(getFieldError(errorKey, error.extensions.validation[errorKey]));
                            }
                        }
                    }
                }
            }
        });
        if (!field.length) {
            general.push(e.graphQLErrors[0].message);
        }
}
    return {general, field};
};



// WEBPACK FOOTER //
// ./src/utils/ErrorHelper.ts